import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Login from "./modules/pages/Login";
import Home from "./modules/pages/Home";
import ProtectedContent from "./modules/utils/ProtectedContent";
import Requests from "./modules/pages/Requests";
import Error from "./modules/pages/Error";
import Profile from "./modules/pages/Profile";
import Documents from "./modules/pages/Documents";
import MessengerChat from "./modules/components/MessengerChat";
import Sidebar from "./modules/components/Sidebar";
import AdminLogin from "./modules/pages/login/Admin";
import { NotificationsProvider } from "./modules/utils/NotificationsContext";
import { NavCountsProvider } from "./modules/utils/NavCountsContext";
import CookieConsent from "./modules/components/CookieConsent";
import ScrollToTop from "./modules/utils/ScrollToTop";

function ProtectedLayout({ children }) {
    return (
        <ProtectedContent>
            <NavCountsProvider>
            <NotificationsProvider>
                <div className="flex min-h-screen w-full overflow-x-hidden">
                    <Sidebar />
                    <div className="app-main flex-1 min-w-0 lg:pt-0 lg:pb-0 pt-[48px] pb-[88px]">
                        {children}
                    </div>
                </div>
                <MessengerChat />
            </NotificationsProvider>
            </NavCountsProvider>
        </ProtectedContent>
    );
}

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Toaster />
            <CookieConsent />
            <Routes>
                <Route path="/" element={<ProtectedLayout><Home /></ProtectedLayout>} />
                <Route path="/profile" element={<ProtectedLayout><Profile /></ProtectedLayout>} />
                <Route path="/documents" element={<ProtectedLayout><Documents /></ProtectedLayout>} />
                <Route path="/requests" element={<ProtectedLayout><Requests /></ProtectedLayout>} />
                <Route path="/login/*" element={<Login />} />
                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/404" element={<Error />} />
                <Route path="*" element={<Navigate to="/404" />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
